import { Component } from '@angular/core';
import { Router, Data } from '@angular/router';
import { FileService } from '../../shared/_services/file.service'
import { MissingData } from '../../shared/models/missingdata.model'
import { HttpEventType } from '@angular/common/http';
import { NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { MyFormatter } from '../../shared/_services/dateformat.service';

@Component({
  selector: 'app-manage-file',
  templateUrl: './manage-file.component.html',
  styleUrls: ['./manage-file.component.css'],
  providers: [{ provide: NgbDateParserFormatter, useClass: MyFormatter }]
})
export class ManageFileComponent {

  missingData: MissingData;
  fileSelected = null;
  progreso: number;
  public message: string;
  error: string;
  finalRoute: string;
  processComplete = false;
  isPhoneFile = false;
  fileName: string;
  cutoffDate: NgbDateStruct ;

  constructor(
    private fileUploadService: FileService,
    private router: Router) {
    this.processComplete = false;
  }
  setFileName(files) {
    let name = files[0].name;
    document.getElementById("textoArchivo").textContent = name;
  }
  upload(files) {
    if (files.length === 0)
      return;

    const formData = new FormData();

    for (let file of files)
      formData.append(file.name, file);
    let cutoffDate: Date = new Date(this.cutoffDate.year, this.cutoffDate.month-1, this.cutoffDate.day);
    this.fileUploadService.uploadFile(formData, this.isPhoneFile, this.fileName, cutoffDate.toDateString())
      .subscribe((event: any) => {
        this.error = undefined;
        if (event.type === HttpEventType.UploadProgress) {
          
          this.progreso = Math.round(event.loaded / event.total * 100);

        } else if (event.type === HttpEventType.Response) {

          this.progreso = undefined;
          this.processComplete = true;
          if (event.status === 202) {           
            //Proceso para continuar Cargando informacion
            //Redirecciona
            this.router.navigate(['/manage-file/fill-branches']);
          } else {
            //proceso finalizar cargue
            this.router.navigate(['/manage-file/download-feedback']);
          }
        }
      },        
      err => {
        this.progreso = undefined;
        this.error = err;
        this.cleanError();
      });    

  }

  cleanError() {
    setTimeout(() => {
      this.error = "";
    }, 7000);
  }
}
